var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 22.56c-1.82 0-3.48-1.4-3.78-3.2L1.29 11.4c-.21-1.24.39-2.83 1.38-3.62L9.6 2.23c1.34-1.08 3.45-1.07 4.8.01l6.93 5.54c.98.79 1.58 2.38 1.38 3.62l-1.33 7.96c-.3 1.77-1.99 3.2-3.78 3.2H6.4zm4.14-19.15L3.61 8.96c-.57.46-.96 1.48-.84 2.2l1.33 7.96c.18 1.05 1.23 1.94 2.3 1.94h11.2c1.07 0 2.12-.89 2.3-1.95l1.33-7.96c.12-.72-.28-1.75-.84-2.2l-6.93-5.54c-.4-.31-.93-.47-1.47-.47-.53 0-1.06.16-1.45.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13c0-1.79 1.46-3.25 3.25-3.25s3.25 1.46 3.25 3.25-1.46 3.25-3.25 3.25S8.75 14.79 8.75 13zm1.5 0c0 .96.79 1.75 1.75 1.75s1.75-.79 1.75-1.75-.79-1.75-1.75-1.75-1.75.79-1.75 1.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHome);
export default __webpack_public_path__ + "static/media/vuesax-outline-home.35ce438ecff691a42f928fcd787c448f.svg";
export { ForwardRef as ReactComponent };